import { SoundType } from '../providers/ActivityAudioProvider/types';

interface ActivitySoundsMap {
  name: string;
  category: string;
  src: {
    src: string;
    captions: string;
  };
}

export const GameSounds = {
  LETTER_AUDIO: (letter: string) => ({
    name: letter,
    category: 'gameSounds',
  }),
};

const FindTheLetterTransform = (data: { [key: string]: any }): SoundType[] => {
  const activitySpecificSounds: Array<ActivitySoundsMap> = [];

  // load the sound for character
  if (data.src) {
    activitySpecificSounds.push({
      name: data.description,
      category: 'gameSound',
      src: {
        src: data.src,
        captions: '',
      },
    });
  }

  return [...activitySpecificSounds];
};

export default FindTheLetterTransform;
